import * as firebase from "firebase/app"
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyA2NxWmd5kT30-z8rW5wzvApK5FMeN2nqU",
    authDomain: "bikeservice-7b111.firebaseapp.com",
    databaseURL: "https://bikeservice-7b111.firebaseio.com",
    projectId: "bikeservice-7b111",
    storageBucket: "bikeservice-7b111.appspot.com",
    messagingSenderId: "637741881875",
    appId: "1:637741881875:web:fc7f304aa2f023baf0bde6",
    measurementId: "G-TDVSHWMJBL"
  };

  const fb = firebase.initializeApp(firebaseConfig)

  const db = firebase.firestore()  
  const auth = firebase.auth()
  let inactivityTimer;

// Funkcja resetująca licznik
const resetTimer = () => {
  clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(() => {
    autoLogout();
  }, 15 * 60 * 1000); // 15 minut (15 * 60 * 1000 ms)
};

// Funkcja do wylogowania użytkownika
const autoLogout = () => {
  auth.signOut()
    .then(() => {console.log("Użytkownik został automatycznie wylogowany z powodu braku aktywności");
    window.location.href = "/login";})
    .catch((error) => console.error("Błąd podczas wylogowywania:", error));
};

// Zdarzenia resetujące licznik
const activityEvents = ["mousemove", "keydown", "click", "scroll"];

activityEvents.forEach(event => {
  window.addEventListener(event, resetTimer);
});

resetTimer(); // Uruchomienie timera po załadowaniu aplikacji

  const usersCollection = db.collection('users')
  const tasksCollection = db.collection('tasks')
  const commentsCollection = db.collection('comments')

  export {
      fb,
      db,
      auth,
      usersCollection,
      tasksCollection,
      commentsCollection
  }